import i18n from "@/i18n";

export const ORDER_STATUS = {
    CANCELLED: 0, // Hủy.
    DRAFT: 20, // Lưu nháp.
    WAIT_DEPOSIT: 40, // Chưa đặt cọc.
    DEPOSIT: 60, // Đã đặt cọc.
    WAIT_RENEWAL: 70, // Chờ gia hạn.
    ON_GOING: 80, // Đang diễn ra.
    WAIT_END: 90, // Chờ tất toán.
    ENDED: 100, // Đã tất toán.
}

export const ASSET_TYPE = {
    BIKE: 1,
    KEY: 2,
    CHARGER: 3,
    HELMET: 4,
}

export const ASSET_TYPE_NAME = {
    1: 'Xe',
    2: 'Chìa khóa',
    3: 'Sạc',
    4: 'Mũ bảo hiểm',
}

export const ORDER_CREATE_DEFAULT_CUSTOMER_INFO = {
    id_channel: null,
    contact_value: null,
    identification_document_type: null,
    identification_document_number: null,
    identification_document_image: null,
    id_country: null,
    gender: null,
    name: null,
    date_of_birth: null,
}

export const ORDER_CREATE_DEFAULT_ITEM = {
    id_voucher: null,
    id_branch: null,
    rent_day: null,
    items: [],
}

export const ORDER_CREATE_DEFAULT_PARTNER_ITEM = {
    id_asset: null,
    rent_day: null,
    note: null,
    count_charger: 0,
}

export const ORDER_RENEWAL_DEFAULT_DATA = {
    id: null,
    id_branch: null,
    rent_day: null,
    rent_hour: 0,
    id_voucher: null
}

export const ORDER_CREATE_DEFAULT_COLLABORATOR_DELIVERY = {
    delivery_type: 2,
    delivery_id_city: null,
    delivery_id_county: null,
    delivery_id_ward: null,
    delivery_address: null,
    id_branch_delivery: null,
    start_time: null,

}

export const ORDER_CREATE_DEFAULT_PARTNER_DELIVERY = {
    delivery_type: 1,
    id_account_delivery_address: null,
    id_branch_delivery: null,
    start_time: null,
}

export const ORDER_CREATE_DEFAULT_SUPPORT_DELIVERY = {
    delivery_type: 1,
    id_account_main: null,
    id_account_delivery_address: null,
    id_branch_delivery: null,
    start_time: null,
    time_type: 1,
}

export const ORDER_CREATE_DEFAULT_BOOKING_DELIVERY = {
    delivery_type: 2,
    delivery_id_city: null,
    delivery_id_county: null,
    delivery_id_ward: null,
    delivery_address: null,
    id_branch_delivery: null,
    start_time: null,
}

export const ORDER_PARTNER_DELIVERY_TYPE = [
    {
        text: 'Địa chỉ đã đăng ký',
        value: 1
    },
    {
        text: 'Cửa hàng EMOVE',
        value: 2
    },
]

export const ORDER_CREATE_DEFAULT_PAYMENT = {
    payment_method: 2,
}

export const ORDER_CREATE_DEFAULT_PAYMENT_BOOKING = {
    payment_method: 1,
}

export const ORDER_CREATE_DEFAULT_CONTRACT = {
    images: [],
}

export const IDENTIFICATION_DOCUMENT_TYPES = [
    {
        text: i18n.t('CCCD'),
        value: 1
    },
    {
        text: i18n.t('Hộ chiếu'),
        value: 2
    },
    {
        text: i18n.t('GPXL'),
        value: 3
    },
    {
        text: i18n.t('MST'),
        value: 9
    },
]

export const IDENTIFICATION_DOCUMENT_NAME = {
    1: i18n.t('CCCD'),
    2: i18n.t('Hộ chiếu'),
    3: i18n.t('GPXL'),
    8: i18n.t('Số HĐ'),
    9: i18n.t('MST'),
}

export const GENDER_OPTIONS = [
    {
        text: i18n.t('Nam'),
        value: 1
    },
    {
        text: i18n.t('Nữ'),
        value: 2
    },
    /* {
        text: i18n.t('Khác'),
        value: 0
    }, */
]

export const NUMBER_TO_TEXT = [
    {
        text: i18n.t('Hóa đơn'),
        value: 1
    },
]

export const YES_NO_OPTIONS = [
    {
        text: i18n.t('Yes'),
        value: 1
    },
    {
        text: i18n.t('No'),
        value: 0
    },
]

export const ORDER_CONTRACT_TYPES = [
    {
        text: i18n.t('Thuê mới'),
        value: 1
    },
    {
        text: i18n.t('Gia hạn'),
        value: 2
    },
]

export const ORDER_CHANNELS = [
    {
        text: i18n.t('Cửa hàng'),
        value: 1
    },
    {
        text: i18n.t('Đại lý'),
        value: 2
    },
    {
        text: i18n.t('CTV - Online'),
        value: 3
    },
    {
        text: i18n.t('CTV - Offline'),
        value: 4
    },
    {
        text: i18n.t('Hợp đồng'),
        value: 5
    },
    {
        text: i18n.t('Booking'),
        value: 6
    },
]

export const ORDER_STATUSES = [
    {
        text: i18n.t('Hủy'),
        value: 0
    },
    {
        text: i18n.t('Nháp'),
        value: 20
    },
    {
        text: i18n.t('Chưa thanh toán'),
        value: 40
    },
    {
        text: i18n.t('Đã thanh toán'),
        value: 60
    },
    {
        text: i18n.t('Chờ gia hạn'),
        value: 70
    },
    {
        text: i18n.t('Đang diễn ra'),
        value: 80
    },
    {
        text: i18n.t('Chờ tất toán'),
        value: 90
    },
    {
        text: i18n.t('Đã tất toán'),
        value: 100
    },
]

export const ORDER_DELIVERY_STATUSES = [
    /* {
        text: i18n.t('Không giao'),
        value: 0,
        color: 'black--text'
    }, */
    {
        text: i18n.t('Chờ tiếp nhận'),
        value: 1,
        count: 0
    },
    {
        text: i18n.t('Đã tiếp nhận'),
        value: 2,
        count: 0
    },
    {
        text: i18n.t('Đang xử lý'),
        value: 3,
        count: 0
    },
    {
        text: i18n.t('Đã xử lý'),
        value: 4,
        count: 0
    },
    {
        text: i18n.t('Hoàn thành'),
        value: 5,
    },
]

export const DELIVERY_TYPES = [
    {
        text: i18n.t('Giao đi'),
        value: 1,
    },
    {
        text: i18n.t('Lấy về'),
        value: 2,
    },
    {
        text: i18n.t('Thu hồi'),
        value: 3,
    },
]

export const ORDER_CLASSIFIES = [

]

export const CUSTOM_VIEW = {
    ORDER_LIST: 1,
    ASSET_PREPAIR_WAIT_LIST: 2,
    DELIVERY_WAIT_LIST: 3,
    INVOICE_LIST: 4,
}

export const STAMP_SIZE_OPTIONS = [
    {
        text: '100%',
        value: '100',
    },
    {
        text: '75%',
        value: '75',
    },
]

export const ASSET_UID_STATUS = {
    AVAILABLE: 10, // Sẵn sàng.
    RETING: 20, // Đang cho thuê.
    WAIT_PREPAIR: 30, // Chờ chuẩn bị.
    PREPARING: 40, // Đang chuẩn bị.
    LOST: 50, // Mất.
    LIQUIDATION: 60, // Thanh lý.
    DAMAGE: 70, // Hư hại.
}

export const ASSET_UID_STATUS_OPTIONS = [
    {
        value: 10,
        text: 'Sẵn sàng'
    },
    {
        value: 20,
        text: 'Đang cho thuê'
    },
    {
        value: 30,
        text: 'Chờ chuẩn bị'
    },
    {
        value: 40,
        text: 'Đang chuẩn bị'
    },
    {
        value: 50,
        text: 'Mất'
    },
    {
        value: 60,
        text: 'Thanh lý'
    },
    {
        value: 70,
        text: 'Hư hại'
    },
]

export const EMPLOYEE_ROLES = [
    {
        text: i18n.t('Nhân viên'),
        value: "employee"
    },
    {
        text: i18n.t('Đại lý'),
        value: "agency"
    },
]

export const INVOICE_TAX_STATUS = [
    {
        text: i18n.t('Đang xử lý'),
        value: 0
    },
    {
        text: i18n.t('Xác thực'),
        value: 2
    },
    {
        text: i18n.t('Đã bị điều chỉnh'),
        value: 3
    },
    {
        text: i18n.t('Đã bị thay thế'),
        value: 4
    },
    {
        text: i18n.t('Đã bị hủy'),
        value: 9
    },
]

export const INVOICE_TYPE = [
    {
        text: i18n.t('Tạo đơn'),
        value: 1
    },
    {
        text: i18n.t('Tất toán'),
        value: 2
    },
]

export const PAYMENT_TYPE = [
    {
        text: i18n.t('Chuyển khoản'),
        value: 1
    },
    {
        text: i18n.t('Quẹt thẻ'),
        value: 2
    },
]

export const CLEAN_CODE = 'EMOVE-CLEANUID-EMOVE'


export const NOTIFICATION_TYPE = {
    D_DELIVERY: 1,
    D_RETURN: 2,
    D_RECOVERY: 3
}

export const NOTIFICATION_TYPE_TEXT = {
    1: 'Yêu cầu giao đi',
    2: 'Yêu cầu lấy về',
    3: 'Yêu cầu thu hồi'
}

export const EXIT_SHOP_CODE = 'EMOVE-EXITSHOP-EMOVE'
export const ACTIVE_SHOP_CODE = 'EMOVE-ACTIVESHOP'